import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
import Select from "react-select";
// import { GlobalContext } from "../../../context/Context";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
} from "../../../../component/form/form-layout";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const AddHealthScoreThresholds = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  editData = {},
}) => {
  let { state, dispatch } = useContext(GlobalContext);

  const apiCall = useApiCall();

  useEffect(() => {
    if (editData?.id) {
      formik.setFieldValue("min_score", editData?.min_score);
      formik.setFieldValue("max_score", editData?.max_score);
      formik.setFieldValue("health_status", editData?.health_status);
      formik.setFieldValue("action_required", editData?.action_required);
      formik.setFieldValue("color", editData?.color);
    }
  }, [editData]);

  const isChanged = () => {
    if (!editData?.id) return true; // new data
    return Object.keys(formik.values).some(
      (key) => formik.values[key] !== editData[key],
    );
  };

  const validationSchema = yup.object({
    health_status: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    min_score: yup
      .number("This Field is Required")
      .required("This Field is Required"),
    action_required: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    color: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    max_score: yup
      .number("This Field is Required")
      .required("This Field is Required"),
  });

  const formik = useFormik({
    initialValues: {
      health_status: "",
      min_score: "",
      action_required: "",
      color: "",
      max_score: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (!isChanged()) {
        console.log("No changes detected. API not called.");
        return;
      }
      let data = {
        health_status: values.health_status,
        min_score: Number(values.min_score),
        action_required: values.action_required,
        color: values.color,
        max_score: Number(values.max_score),
      };
      // console.log("DATae", data);

      try {
        let apiRes;

        apiRes = await apiCall({
          method: "post",
          url: editData?.id
            ? `health-score-thresholds/update-threshold/${editData?.id}`
            : `health-score-thresholds/add-threshold`,
          data: data,
        });

        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error);
        const res = error?.response?.data;

        if (res?.errors) {
          formik.setErrors(
            Object.fromEntries(
              Object.entries(res.errors).map(([key, value]) => [key, value[0]]),
            ),
          );
        }
        onError(
          error?.response.data?.respMsg ||
            error?.response.data?.responseMessage ||
            error?.response.data?.message ||
            "Some Thing Went Wrong",
        );
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <h4>
            {editData?.id
              ? "Edit Health Score Thresholds"
              : "Add Health Score Thresholds"}
          </h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                <FormArea>
                  {/* Health Status */}
                  <FeildWraper width="100%">
                    <FormLabel required>Health Status</FormLabel>
                    <input
                      type="text"
                      name="health_status"
                      value={formik.values.health_status}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      placeholder="Health Status"
                    />
                    {formik.touched.health_status &&
                      formik.errors.health_status && (
                        <FeildError>{formik.errors.health_status}</FeildError>
                      )}
                  </FeildWraper>

                  {/* min_score */}
                  <FeildWraper>
                    <FormLabel required>Min Score</FormLabel>
                    <input
                      type="number"
                      name="min_score"
                      min="0"
                      value={formik.values.min_score}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      placeholder="Min Score"
                    />
                    {formik.touched.min_score && formik.errors.min_score && (
                      <FeildError>{formik.errors.min_score}</FeildError>
                    )}
                  </FeildWraper>

                  {/* max_score */}
                  <FeildWraper>
                    <FormLabel required>Max Score</FormLabel>
                    {/* <input
                      type="number"
                      name="max_score"
                      min="0"
                      value={formik.values.max_score}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      placeholder="Max Score"
                    /> */}
                    <input
                      type="text"
                      name="max_score"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={formik.values.max_score}
                      onBlur={formik.handleBlur}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        formik.setFieldValue("max_score", value);
                      }}
                      placeholder="Max Points"
                    />
                    {formik.touched.max_score && formik.errors.max_score && (
                      <FeildError>{formik.errors.max_score}</FeildError>
                    )}
                  </FeildWraper>

                  {/* action_required */}

                  <FeildWraper>
                    <FormLabel required>Action Required</FormLabel>
                    <input
                      type="text"
                      name="action_required"
                      value={formik.values.action_required}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      placeholder="Action Required"
                    />
                    {formik.touched.action_required &&
                      formik.errors.action_required && (
                        <FeildError>{formik.errors.action_required}</FeildError>
                      )}
                  </FeildWraper>

                  {/* color */}

                  <FeildWraper>
                    <FormLabel required>Color</FormLabel>
                    <input
                      type="text"
                      name="color"
                      value={formik.values.color}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      placeholder="Color"
                    />
                    {formik.touched.color && formik.errors.color && (
                      <FeildError>{formik.errors.color}</FeildError>
                    )}
                  </FeildWraper>
                </FormArea>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button
            type="submit"
            className={`${Style.dcmb__submit} disabled:!opacity-70 disabled:!cursor-not-allowed`}
            disabled={!isChanged()}
          >
            {editData?.id ? "Update" : "Apply"}
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default AddHealthScoreThresholds;
